import * as React from 'react';

export const FaceGrinHeartsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="face-grin-hearts">
      <path
        id="Vector"
        opacity="0.4"
        d="M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22Z"
        fill="#44AF42"
      />
      <path
        id="Vector_2"
        d="M9.20628 11.46C9.20628 11.46 7.10628 11.3 6.30628 9.96998C5.81628 9.15998 5.86628 8.13998 6.80628 7.79998C7.50628 7.53998 8.04629 8.27998 8.04629 8.27998C8.04629 8.27998 7.97629 7.36998 8.68629 7.10998C9.63629 6.76998 10.3163 7.51998 10.4663 8.44998C10.7063 9.97998 9.20628 11.45 9.20628 11.45V11.46ZM17.1963 7.78997C16.4963 7.52997 15.9963 8.14997 15.9963 8.14997C15.9963 8.14997 16.0163 7.35998 15.3163 7.09998C14.3663 6.75998 13.6763 7.50998 13.5263 8.43998C13.2863 9.96998 14.7863 11.45 14.7863 11.45C14.7863 11.45 16.8963 11.29 17.6863 9.95999C18.1763 9.14999 18.1263 8.12998 17.1863 7.77998L17.1963 7.78997ZM8.73627 14.27C8.35628 14.12 7.92628 14.42 8.02628 14.82C8.44628 16.64 10.0663 17.99 12.0163 17.99C13.9663 17.99 15.5863 16.64 16.0063 14.82C16.0963 14.42 15.6763 14.11 15.2963 14.27C13.1163 15.14 10.9363 15.14 8.74628 14.27H8.73627Z"
        fill="#44AF42"
      />
    </g>
  </svg>
);
